// extracted by mini-css-extract-plugin
export default {"tx":"_4ca190e37b","line":"e205085ed1"};